/**
 * Active-underline tab indicator shared by SectionTabs and SubNavItem: an
 * absolute ::after rule pinned to the item's bottom edge, revealed by a fading
 * opacity toggle. Activation stays with the consumer (`selected:` for
 * react-aria tabs, an `isActive` variant for nav items), as do responsive
 * geometry overrides.
 */
export const tabUnderlineClasses =
  "after:absolute after:inset-x-0 after:bottom-0 after:opacity-0 after:transition-opacity";

/** Underline thickness (Tailwind height scale: 0.5 = 2px, 1 = 4px). */
export const tabUnderlineThickness = {
  "0.5": "after:h-0.5",
  "1": "after:h-1",
} as const;

/**
 * Underline tint. `accent` follows the `data-accent` scope its consumer opens;
 * the literals are for consumers with a fixed tint.
 */
export const tabUnderlineColor = {
  accent: "after:bg-secondary",
  "green-500": "after:bg-green-500",
  "neutral-900": "after:bg-neutral-900",
} as const;
